import React, { createContext, useContext, forwardRef } from 'react'
import { useClickOutside, useIsMobile } from '../../hooks'

const DropdownContext = createContext()
const useDropdownContext = () => useContext(DropdownContext)

const DropdownConsumer = DropdownContext.Consumer

const DropdownProvider = forwardRef(
  (
    { children, mobileHeading, alignContent, contentPosition, themeColor },
    ref
  ) => {
    const { isMobile } = useIsMobile()
    const { isOpen, toggle } = useClickOutside(ref)

    const onBlur = (e) => {
      const el = ref.current
      const { relatedTarget, target } = e

      if (!el.contains(relatedTarget || target) && isOpen) {
        toggle()
      }
    }

    const dropdownContentId = `dropdown-content${Math.random().toString(36).slice(2, 11)}`

    const state = {
      isMobile,
      isOpen,
      toggle,
      mobileHeading,
      alignContent,
      contentPosition,
      onBlur,
      themeColor,
      dropdownContentId
    }

    return (
      <DropdownContext.Provider value={state}>
        {children}
      </DropdownContext.Provider>
    )
  }
)

export { DropdownConsumer, DropdownProvider, useDropdownContext }
